import { api } from "../../api"

export async function loadModules(): Promise<Module[]> {
    let module = await api<Module[]>("module", {})
    return module.data
}
